// Import Firebase functions
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase config (from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyDY-_yPyFootPqeBCJOhKfHB8ED44jFFyk",
  authDomain: "polu-techonology-sms.firebaseapp.com",
  projectId: "polu-techonology-sms",
  storageBucket: "polu-techonology-sms.firebasestorage.app",
  messagingSenderId: "784706351310",
  appId: "1:784706351310:web:67e2c42d3389899ce0609f",
  measurementId: "G-7FZZKJEHM9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase messaging instance
export const messaging = getMessaging(app);

// Function to get device token
export const getDeviceToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BASYfW32G9Wk_yRmIkailVUOayMnxZBQ_yLV7R5A7eSAfiNSzcVLKiQ6Dj-eWZ_MqtvUeceSc3Zlnj5o1Wmbaso"
    });
    return currentToken;
  } catch (err) {
    console.error("Error getting device token: ", err);
    return null;
  }
};

// Listen to foreground messages
export const onMessageListener = (callback) => {
  onMessage(messaging, callback);
};
